export { default } from "./loader.react.js";
